import { AllPersonnelThemeSizeConfig } from './types';

const small: AllPersonnelThemeSizeConfig = {
  allPersonnel: {},
};

export default small;
